/**
 * for others...
 * initTrackers를 외부에서 호출하여 tracker를 선택적으로 등록하는 형태가 필요해서..
 */

import { TrackerEvent } from './src/tracker-event';

import { track, register, TRACKER_CLASS_MAP, setTrackerVariableToGivenContext } from './src/common';
import config from './src/config';

// 전역변수 `$fc`에 `tracker()` & `track()` 함수 주입.

const initTrackers = ({ context, scope, options }) => {
  const completeInitiatingTracker = context.Event && new context.Event('completeInitiatingTracker');
  if (context && !context.$fc) {
    setTrackerVariableToGivenContext(context);
    if (!TRACKER_CLASS_MAP[scope]) {
      console.error('unregistered scope', scope);
      return;
    }
    for (const trackerName of Object.keys(TRACKER_CLASS_MAP[scope])) {
      register({
        Tracker: TRACKER_CLASS_MAP[scope][trackerName],
        config: config[scope][trackerName.toLowerCase()],
        context,
        options,
      });
    }
    context.dispatchEvent && context.dispatchEvent(completeInitiatingTracker);
  }
};

export { TrackerEvent, initTrackers, track };
